import { useUI } from '@components/ui'
import { EmptyGuid } from '@components/utils/constants'
import { GA_EVENT } from 'hooks/ga_event.modal'
import { useGoogleAnalyticsEvent } from 'hooks/useGAEvent'
import NextHead from 'next/head'
import Link from 'next/link'
import { isMobileOnly } from 'react-device-detect'

export const StoreHead = ({ getSubHeader, previousPath, deviceInfo }: any) => {
  const { isMobile, isIPadorTablet } = deviceInfo
  const { user } = useUI()
  const trackGoogleAnalyticsEvent = useGoogleAnalyticsEvent()
  let deviceCheck = ''
  if (isMobile || isIPadorTablet) {
    deviceCheck = 'Mobile'
  } else {
    deviceCheck = 'Desktop'
  }

  const backbtnGAEvent = () => {
    trackGoogleAnalyticsEvent(
      GA_EVENT.BACK_BUTTON,
      {
        current_page: window?.location?.href,
        previous_page: previousPath,
        device: deviceCheck,
        loggedin_status: !!(user?.userId && user?.userId !== EmptyGuid),
      },
      window
    )
  }
  return (
    <>
      <NextHead>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, maximum-scale=1"
        />
        <link
          rel="canonical"
          id="canonical"
          href="https://www.damensch.com/stores"
        />
        <title>
          DaMENSCH Clothing Store Near Me | Premium Mens wear in India
        </title>
        <meta
          name="title"
          content="DaMENSCH Clothing Store Near Me | Premium Mens wear in India"
        />
        <meta
          property="og:title"
          content="DaMENSCH Clothing Store Near Me | Premium Mens wear in India"
          key="ogtitle"
        />
        <meta
          property="og:description"
          content="DaMENSCH is a leading brand which deals in premium range of men's wear collections. Now available offline. You can search DaMENSCH clothing near me & visit us!"
          key="ogdesc"
        />
        <meta
          name="description"
          content="DaMENSCH is a leading brand which deals in premium range of men's wear collections. Now available offline. You can search DaMENSCH clothing near me & visit us!"
        />
        <meta
          name="keywords"
          content="clothing store, menswear collection, premium collection, leading brand,men's fashion"
        />
      </NextHead>
      <h1 className="hidden">men's clothing store</h1>
      <div
        className={` text-primary ${
          isMobile
            ? 'sticky top-0 w-full z-50 pt-4 bg-white border-b shadow-sm mob-header'
            : 'mb-4 px-[10%] pt-[20px] desktop-laptop'
        }`}
      >
        <div
          className={`flex items-center px-5 ${
            isMobileOnly ? 'h-[48px]' : 'pb-[16px]'
          }`}
        >
          <span>
            <Link legacyBehavior href="/">
              <a className="mr-2 leading-none" onClick={() => backbtnGAEvent()}>
                <i className="sprite-icon sprite-left-arrow" />
              </a>
            </Link>
          </span>
          <span>
            <h1 className={`font-semibold text-primary text-base`}>
              {isMobileOnly
                ? 'Store Locator'
                : 'Find a DaMENSCH Store near you'}
            </h1>
          </span>
        </div>
        {isMobile ? getSubHeader() : ''}
      </div>
    </>
  )
}
